import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CatalogItemsDataMainComponent } from './components/main/catalog-items-data-main.component';
import { CatalogItemsDataRouting } from './models/catalog-items-data-routing';
import { CatalogItemsComponent } from './components/catalog-items/catalog-items.component';
import { CatalogMapComponent } from './components/catalog-map/catalog-map.component';
import { CatalogDescriptionComponent } from './components/description/catalog-description.component';
import { CatalogPassportTabComponent } from './components/catalog-passport-tab/catalog-passport-tab.component';
import { EnLanguagesGuard } from '../../../../en-languages.guard';

const childRoutes: Routes = [
  { path: CatalogItemsDataRouting.CatalogItems, component: CatalogItemsComponent, canActivate: [EnLanguagesGuard] },
  { path: CatalogItemsDataRouting.Map, component: CatalogMapComponent },
  { path: 'data/map', redirectTo: CatalogItemsDataRouting.Map },
  { path: CatalogItemsDataRouting.Passport, component: CatalogPassportTabComponent },
  { path: CatalogItemsDataRouting.Description, component: CatalogDescriptionComponent },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: CatalogItemsDataRouting.CatalogItems
  }
];

export const routes: Routes = [
  {
    path: '',
    component: CatalogItemsDataMainComponent,
    children: childRoutes
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CatalogItemsDataRoutingModule {}
